import { Box, Center, Heading, Text } from "@highoutput/ui-components";
import Image from "next/image";

export default function Empty() {
  return (
    <Box>
      <Center>
        <Box position="relative" width="226px" height="202px">
          <Image src="/images/404.webp" alt="" width={250} height={250} />
        </Box>
      </Center>
      <Heading
        variant={{
          base: "32/36",
          lg: "40/44",
        }}
        letterSpacing={{
          base: "-0.02em",
          lg: "unset",
        }}
        marginTop="32px"
        textAlign="center"
      >
        No result found
      </Heading>

      <Text
        marginTop="16px"
        variant={{
          base: "16/24",
          lg: "24/36",
        }}
        letterSpacing={{
          base: "0.02em",
          lg: "unset",
        }}
        color="rgba(13,48,80,0.8)"
        textAlign="center"
      >
        Sorry, it seems like we can’t find any results based on your search.
      </Text>
    </Box>
  );
}
